import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { useModal } from '@app/components/modal-views/context';
import { useUpdateProjectInvitationRoleMutation, useUpdateProjectMemberRoleMutation } from '@app/store/project/api';
import { useUpdateOrganizationInvitationRoleMutation, useUpdateOrganizationMemberRoleMutation } from '@app/store/organization/api';
import { MemberDto, MemberInvitationDto } from '@app/store/project/types';
import { updateMemberRoleRequest } from '@app/store/organization/types';
import { ToastId } from '@app/constants/ToastId';
import { useTranslation } from 'next-i18next';
import { statusErrorMessageHandler } from '@app/utils/errorUtils';

function UseUpdateRole() {
    const router = useRouter();
    const { closeModal } = useModal();
    const { t } = useTranslation(['common']);
    const [updateProjectMemberRole] = useUpdateProjectMemberRoleMutation();
    const [updateOrganizationMemberRole] = useUpdateOrganizationMemberRoleMutation();
    const [updateProjectInvitationRole] = useUpdateProjectInvitationRoleMutation();
    const [updateOrganizationInvitationRole] = useUpdateOrganizationInvitationRoleMutation();
    const handleUpdateRoleApiRequest = async (member: MemberDto | MemberInvitationDto, role: string) => {
        const request: updateMemberRoleRequest = {
            organizationId: router.query.organizationId ?? '',
            projectId: router.query.projectId,
            role: role.toLowerCase(),
            identifier: 'userInfo' in member ? member.userInfo.userId : member.token
        };
        let response;
        if ('userInfo' in member) {
            if (router.query.projectId) {
                response = await updateProjectMemberRole(request);
            } else {
                response = await updateOrganizationMemberRole(request);
            }
        } else {
            if (router.query.projectId) {
                response = await updateProjectInvitationRole(request);
            } else {
                response = await updateOrganizationInvitationRole(request);
            }
        }
        if ('data' in response) {
            toast.success(`${t('toast.roleUpdated')}`, { toastId: ToastId.UPDATE_ROLE_SUCCESS_TOAST });
            closeModal();
        }
        if ('error' in response) {
            // @ts-ignore
            statusErrorMessageHandler(response.error.originalStatus || response.error.status, t);
            closeModal();
        }
    };

    return { handleUpdateRoleApiRequest };
}

export default UseUpdateRole;
